<template>
	<div class="px-lg-2 px-xl-4">
		<!-- Encabezado de ubicación (Breadcum)-->
		<div class="row d-flex align-items-center">
			<div class="col-12 col-sm-7 pl-0">
				<nav aria-label="breadcrumb ">
					<ol class="breadcrumb pl-0">
						<li class="breadcrumb-item">Adeudos</li>
					</ol>
				</nav>
			</div>
		</div>

		<div class="row form-group form-inline border p-md-2 px-md-3 mb-3 bg-white text-right">
			<span class="ml-2 ml-md-auto mr-4">Estatus saldo:</span>
			<span class="mr-3">
				<span class="circle-green mx-md-2"></span>No vencido
			</span>
			<span class="mr-3">
				<span class="circle-yellow mx-md-2"></span>Por vencer
			</span>
			<span class="mr-3">
				<span class="circle-red mx-md-2"></span>Vencido
			</span>
		</div>

		<div class="row form-group bg-white">
			<a class="form-control btn-blue-1" role="button" v-b-toggle.collapse-info>Información de crédito</a>
			<b-collapse class="w-100" id="collapse-info" @shown="updateFloatThead" @hidden="updateFloatThead">
				<div class="row" v-if="antiguedad">
					<div class="col-4 font-14 font-blue1">
						<div class="my-2 ml-2">
							<div class="font-weight-bold mb-3">Datos del agente</div>
							<div>Nombre: {{ antiguedad.nombre }}</div>
							<div>Teléfono: {{ formatPhoneNumber(antiguedad.telefono) }}</div>
							<div>Correo: {{ antiguedad.email }}</div>
						</div>
					</div>

					<div class="col-4 font-14 font-blue1">
						<div class="my-lg-2 mx-lg-2">
							<div class="font-weight-bold mb-3">Mis condiciones</div>
							<div class="row">
								<div class="col">Plazo:</div>
								<div class="col text-right">{{ antiguedad.plazo }} días</div>
							</div>
							<div class="row">
								<div class="col">Limite de crédito:</div>
								<div
									class="col d-flex justify-content-end align-items-end"
								>{{ antiguedad.limiteCredito | format-number('$0,0.00') }}</div>
							</div>
							<div class="row">
								<div class="col">Crédito disponible:</div>
								<div
									class="col d-flex justify-content-end align-items-end"
								>{{ antiguedad.limiteCredito - saldoTotalMostrar | format-number('$0,0.00') }}</div>
							</div>
						</div>
					</div>

					<div class="col-4 font-14 font-blue1">
						<div class="my-lg-2 mx-lg-2">
							<div class="font-weight-bold mb-3">Resumen de la cuenta</div>
							<div class="row">
								<div class="col">Monto vencido:</div>
								<div
									class="col d-flex justify-content-end align-items-end"
								>{{ montoVencidoTotal | format-number('$0,0.00') }}</div>
							</div>
							<div class="row">
								<div class="col">Monto no vencido:</div>
								<div
									class="col d-flex justify-content-end align-items-end"
								>{{ antiguedad.limiteCredito - (antiguedad.creditoDisponible + montoVencidoTotal) | format-number('$0,0.00') }}</div>
							</div>
							<div class="row">
								<div class="col">Último abono:</div>
								<div
									class="col d-flex justify-content-end align-items-end"
								>{{ antiguedad.fechaUltimoAbono | format-date('DD/MMM/YYYY') }}</div>
								<div
									class="col d-flex justify-content-end align-items-end"
								>{{ antiguedad.ultimoAbono | format-number('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>
			</b-collapse>
		</div>

		<div class="row form-group bg-white">
			<a class="form-control btn-blue-1" role="button" v-b-toggle.collapse-cuentas>
				<span class="d-none d-md-inline">Ponemos a su disposicion nuestras cuentas bancarias</span>
				<span class="d-md-none d-inline">Cuentas bancarias</span>
			</a>
			<b-collapse id="collapse-cuentas" @shown="updateFloatThead" @hidden="updateFloatThead" v-model="mcb">
				<div class="row font-14 my-2 mx-3 font-blue1">
					<div class="col col-md-3 mb-4">
						<img class="img-fluid" src="@/assets/img-priv/citibanamex-logo.png" />
						<div>
							<div class="font-weight-bold my-2">Cuenta: 4417715644</div>
							<div class="font-weight-bold my-2">CLABE: 002730044177156441</div>
						</div>
					</div>
					<div class="col col-md-3">
						<img class="img-fluid" src="@/assets/img-priv/Banorte.png" />
						<div>
							<div class="font-weight-bold my-2">Cuenta: 0636158975</div>
							<div class="font-weight-bold my-2">CLABE: 072730006361589753</div>
						</div>
					</div>
					<div class="col col-md-3">
						<img class="img-fluid" src="@/assets/img-priv/BBVA.png" />
						<div>
							<div class="font-weight-bold my-2">Cuenta: 0446632831</div>
							<div class="font-weight-bold my-2">CLABE: 012730004466328318</div>
						</div>
					</div>
					<div class="col col-md-3">
						<img class="img-fluid" src="@/assets/img-priv/bancoppel.png" />
						<div>
							<div class="font-weight-bold my-2">Cuenta: 12000002893</div>
							<div class="font-weight-bold my-2">CLABE: 137730120000028930</div>
						</div>
					</div>

					<div class="col col-md-3">
						<img class="img-fluid" src="@/assets/img-priv/HSBC-logo.png" />
						<div>
							<div class="font-weight-bold my-2">Cuenta: 4040354235</div>
							<div class="font-weight-bold my-2">CLABE: 021730040403542351</div>
						</div>
					</div>
					<div class="col col-md-3">
						<img class="img-fluid" src="@/assets/img-priv/santander.png" />
						<div>
							<div class="font-weight-bold my-2">Cuenta: 65505450876</div>
							<div class="font-weight-bold my-2">CLABE: 014730655054508764</div>
						</div>
					</div>

					<div class="col col-md-3">
						<img class="img-fluid" src="@/assets/img-priv/Banbajio.png" />
						<div>
							<div class="font-weight-bold my-2">Cuenta: 0220484170201</div>
							<div class="font-weight-bold my-2">CLABE: 030730900014596160</div>
						</div>
					</div>

					<div class="col col-md-3">
						<img class="img-fluid imagen-banco" src="@/assets/img-priv/BancoAzteca.png" />
						<div>
							<div class="font-weight-bold my-2">Cuenta: 01720100318588</div>
							<div class="font-weight-bold my-2">CLABE: 127180001003185889</div>
						</div>
					</div>

					<div class="col col-md-3 mt-3">
						<img class="img-fluid imagen-banco" src="@/assets/img-priv/scotiabank.png" />
						<div>
							<div class="font-weight-bold my-2">Cuenta: 25601048212</div>
							<div class="font-weight-bold my-2">CLABE: 044730256010482125</div>
						</div>
					</div>

				</div>
			</b-collapse>
		</div>

		<div
			class="row form-group form-inline border p-2 px-3 mb-3 bg-white text-right font-weight-bold font-blue1"
			v-if="antiguedad"
		>
			<span class="ml-auto mr-4">Saldo Total:</span>
			<span
				class="mr-3"
			>{{ saldoTotalMostrar | format-number('$0,0.00') }}</span>
		</div>

		<div class="row">
			<div class="col">
				<table class="table table-sm font-14" ref="tabla-adeudos">
						<thead class="thead">
							<tr>
								<th class="text-center">Documento</th>
								<th class="d-table-cell d-md-none text-center">Fecha</th>
								<th class="text-center">Estatus</th>
								<th class="d-md-table-cell d-none text-center">Fecha</th>
								<th class="text-center d-md-table-cell d-none">Días vencido</th>
								<th class="text-center d-md-table-cell d-none">Importe</th>
								<th class="text-center d-md-table-cell d-none">Vencimiento</th>
								<th class="text-center d-md-table-cell d-none">Abono real</th>
								<th class="text-center d-md-table-cell d-none">Abono virtual</th>
								<th class="text-center d-md-table-cell d-none">Nota de crédito</th>
								<th class="text-center d-md-table-cell d-none">Total</th>
							</tr>
						</thead>
						<tbody v-if="antiguedad">
							<tr :key="index" v-for="(saldo, index) in antiguedad.detalle">
								<td class="text-center">{{saldo.documento}}</td>
								<td
									class="d-table-cell d-md-none text-center"
								>{{ saldo.fechaDocumento | format-date('DD/MMM/YY') }}</td>
								<td class="d-flex justify-content-center">
									<span class="b-danger text-white" v-show="saldo.color == 1">Vencido</span>
									<span class="b-warning" v-show="saldo.color == 2">Por vencer</span>
									<span class="b-success text-white" v-show="saldo.color == 3">No vencido</span>
								</td>
								<td
									class="text-center d-md-table-cell d-none"
								>{{ saldo.fechaDocumento | format-date('DD/MMM/YYYY')}}</td>
								<td class="text-center d-md-table-cell d-none">{{ saldo.diasVencido }}</td>
								<td class="text-right d-md-table-cell d-none">{{ saldo.importe | format-number('$0,0.00') }}</td>
								<td
									class="text-center d-md-table-cell d-none"
								>{{ saldo.fechaVencimiento | format-date('DD/MMM/YYYY')}}</td>
								<td
									class="text-right d-md-table-cell d-none"
								>{{ saldo.abonoReal | format-number('$0,0.00') }}</td>
								<td
									class="text-right d-md-table-cell d-none"
								>{{ saldo.abonoVirtual | format-number('$0,0.00') }}</td>
								<td
									class="text-right d-md-table-cell d-none"
								>{{ saldo.notaCredito | format-number('$0,0.00') }}</td>
								<td class="text-right d-md-table-cell d-none">{{ saldo.total | format-number('$0,0.00') }}</td>
							</tr>
						</tbody>
					</table>
				<div class="table-responsive bg-white border tabla-adeudos-wrapper" ref="tablita">
					
				</div>
			</div>			
		</div>

		<div
			class="row form-group form-inline border p-2 px-3 mb-3 bg-white text-right font-weight-bold font-blue1"
			v-if="antiguedad"
		>
			<span class="ml-auto mr-4">Saldo Total:</span>
			<span
				class="mr-3"
			>{{ saldoTotalMostrar | format-number('$0,0.00') }}</span>
			<!-- >{{ antiguedad.saldoTotal antiguedad.limiteCredito - antiguedad.creditoDisponible | format-number('$0,0.00') }}</span> -->
		</div>
	</div>
</template>
<script>
	import servicio from "@/services/servicio-adeudos-pagos"

	export default {
		data() {
			return {
				antiguedad: null,
				importePagar: 0,
				pagarTodos: false,
				importeBanco: 0,
				montoVencidoTotal: 0,
				saldoTotalMostrar: 0,
				multipagos: {
					mp_order: JSON.parse(this.lsTokenDifarmer().user).idUsuario,  //window.localStorage.user.idUsuario, // codigo del cliente
					referencia: 0,
					mp_node: 1, //codigo de la sucursal
					mp_customername: JSON.parse(this.lsTokenDifarmer().user).nombre,//window.localStorage.user.nombre, // nombre del cliente
					signature: "",
					mp_urlback: "",
				},
				tabla: null,
				mcb: false
			}
		},
		mounted() {
			this.carritoConsultarCantidad()
			this.obtenerNotificaciones()
			//console.log(window.localStorage.user.idUsuario)
			this.cargar()

			this.mcb = this.$route.query.mcb != undefined			
		},
		methods: {
			updateFloatThead(){
				this.$nextTick(()=>{
					this.tabla?.floatThead('reflow')
				})
			},
			pagar() {
				servicio
					.pagar()
					.then((r) => {
						r = r.data
						console.log(r)

						let form = document.querySelector("#multipagos")
						let importe = document.querySelector("#multipagos-importe")
						let referencia = document.querySelector("#multipagos-ref")
						let signature = document.querySelector("#multipagos-signature")

						importe.value = this.importeBanco
						referencia.value = r.data.idPago
						signature.value = r.data.signature

						form.submit()
					})
					.catch((error) => {
						console.error(error)
					})

				//this.$refs.multipagos.submit();
			},
			importePagarFocus() {
				this.$refs.inputpago.select()
			},
			importePagarBlur() {
				this.calcular()
			},
			calcularTodo() {
				this.importePagar = 0

				if (this.pagarTodos) {
					this.antiguedad.detalle.forEach(
						(item) => (this.importePagar += item.saldoActual)
					)

					this.importePagar = this.importePagar.toFixed(2)
				} else {
					this.antiguedad.detalle.forEach((item) => {
						item.saldo = item.saldoActual
						item.abono = 0
					})
				}

				this.calcular()
			},
			calcular() {
				let importeDistribuir = this.importePagar

				var detalle = this.antiguedad.detalle.map((item) => {
					item.checked = 0
					item.abono = 0
					item.saldo = item.saldoActual

					if (importeDistribuir > 0) {
						item.checked = true

						if (item.saldo <= importeDistribuir) {
							item.abono = item.saldo
							//console.log("el saldo es menor al importe a distribuir", importeDistribuir)
						} else {
							item.abono = importeDistribuir
							///console.log("el saldo es mayor al importe a distribuir", importeDistribuir)
						}
						//console.log(item.saldo, item.abono)

						item.saldo = item.saldo - item.abono
						importeDistribuir -= item.abono
					}

					return item
				})

				this.antiguedad.detalle = detalle
				this.importeBanco = this.importePagar
			},
			calcularCheck() {
				this.importePagar = 0
				this.antiguedad.detalle.forEach((item) => {
					if (item.checked) {
						item.abono = item.saldoActual

						this.importePagar += item.abono
					} else {
						item.abono = 0
					}

					item.saldo = item.saldoActual - item.abono
				})

				this.importePagar = this.importePagar.toFixed(2)
				this.importeBanco = this.importePagar
			},
			update() {
				this.calcularCheck()
			},
			cargar() {
				this.$loading(true)
				this.montoVencidoTotal = 0
				servicio
					.adeudos()
					.then((r) => {
						this.$loading(false)

						if (!r.value) return

						this.antiguedad = r.data
						//console.log("this.antiguedad", this.antiguedad)
						this.saldoTotalMostrar = 0
						this.antiguedad.detalle.map((item) => {
							item.saldoActual = item.importe - item.abonoReal - item.abonoVirtual

							item.saldo = item.saldoActual
							item.abono = 0
							item.checked = false
							//console.log('tag', item.total)
							this.saldoTotalMostrar += item.total
							if (item.color == 1) {
								this.montoVencidoTotal += item.total
							}
						})

						this.$nextTick(()=>{
							
							let t = this.$refs['tabla-adeudos']
							//console.log("entro", t)

							this.tabla = this.$floatThead.ini(t)
							/*
							{
								scrollContainer: function($table){
									return $table.closest('.tabla-adeudos-wrapper')
								}
							}
							*/
						})

						//console.log(this.antiguedad.detalle)
					})
					.catch((error) => {
						this.$loading(false)
						console.log(error)
					})
			},
			formatPhoneNumber(numeroTelefono) {
				var x = numeroTelefono.match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
				return !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? " " + x[3] : "")
			},
		},
	}
</script>
<style scoped>

	.imagen-banco{
		height: 42px;
	}

	.fuente-no-vencido {
		font-size: 13px !important;
	}
	.Titulo {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		font-weight: bold;
	}
	a::after {
		font-family: "Font Awesome 5 Free";
		font-weight: 900;
		content: "\f107";
		margin-left: 10px;
	}

	a[aria-expanded="true"]::after {
		font-family: "Font Awesome 5 Free";
		font-weight: 900;
		content: "\f106";
		margin-left: 10px;
	}

	.font-14 {
		font-size: 14px !important;
	}

	.font-blue1 {
		color: #335198 !important;
	}

	.circle-green {
		border-radius: 50%;
		width: 10px;
		height: 10px;
		background-color: #63cb5c;
		display: inline-block;
	}

	.circle-yellow {
		border-radius: 50%;
		width: 10px;
		height: 10px;
		background-color: #f4d06d;
		display: inline-block;
	}

	.circle-red {
		border-radius: 50%;
		width: 10px;
		height: 10px;
		background-color: #e96262;
		display: inline-block;
	}

	.float-pagar {
		position: fixed;
		bottom: 3em;
		right: 3em;
		width: 300px;
		background-color: #dedede;
		padding: 1em 1.6em;
		color: #335198;
		font-weight: bold;
	}

	.float-pagar .importe {
		display: flex;
		justify-content: space-around;
	}

	.float-pagar .btn {
		background-color: #335198;
		color: #fff;
	}

	.float-pagar .btn:hover {
		background-color: #273c6e;
	}

	.thead {
		background-color: #335198;
		color: #fff;
	}

	.thead > tr > th {
		padding: 0.5em;
	}

	.b-danger {
		background-color: #e96262;
		color: white;
		padding: 0.2em 1em;
		border-radius: 5px;
		width: 7em;
		display: block;
		text-align: center;
		font-weight: bold;
	}

	.b-warning {
		background-color: #f1c240;
		color: var(--bg-menu-blue);
		padding: 0.2em 1em;
		border-radius: 5px;
		width: 7em;
		display: block;
		text-align: center;
		font-weight: bold;
	}

	.b-success {
		background-color: #63cb5c;
		color: var(--bg-menu-blue);
		padding: 0.1em 0em;
		border-radius: 5px;
		width: 7em;
		display: block;
		text-align: center;
		font-weight: bold;
	}

	table {
		color: #273c6e;
	}
</style>